module.exports = __webpack_public_path__ + "static/media/18ECA11.e08a01ae.jpg";